import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Account from "@/components/Account.vue";
import ViewRouter from "@/components/ViewRouter.vue";
import ViewRouterSwitch from '@/components/ViewRouterSwitch.vue';
import { Route, RouteRecord } from "vue-router";
import { Consts } from './consts';
import { AuthResult } from './models/authResult';
import { AuthUtils } from './utils/authUtils';
import { MsalResult } from './enums';
import Confirmation from '@/views/Confirmation.vue';
import { AppUtils } from './utils/appUtils';
import { Groups } from './models/groups';
import Combobox from '@/components/Combobox.vue';

@Component({
	components: {
		Account,
		Confirmation,
		Combobox,
		ViewRouter,
		ViewRouterSwitch
	}
})
export default class App extends Vue {
	private isRouterVisible: boolean = false;
	private routerTitle: string = "";
	private routerPath: string = "";
	private isRouterSwitchVisible: boolean = false;
	private isRouterSwitchOn: boolean = false;
	private routerSwitchPathOn: string = '';
	private routerSwitchPathOff: string = '';
	private isAccountVisible: boolean = false;
	private userName: string = '';
	private isAdmin: boolean = false;
	private isLogoutConfirmationVisible: boolean = false;
	private logoutConfirmationTitle: string = Consts.EMPTY_STRING;
	private logoutConfirmationMessage: string = Consts.EMPTY_STRING;
	private logoutConfirmationOkButtonDisabled: boolean = false;
	private logoutConfirmationCancelButtonDisabled: boolean = false;
	private groupId: string = '';
	private groupName: string = '';
	private groups: Groups = new Groups();
	private isGroupListIconVisible: boolean = false;
	private isGroupListVisible: boolean = false;

	public async created(): Promise<void> {
	}

	public async mounted(): Promise<void> {
	}

	public async updated(): Promise<void> {
		// このラインでリダイレクトコールバック（コールバック関数は空でも動作可能）を設定することで、
		// AuthUtils.acquireTokenSilent()によるアクセストークンの取得が可能になる。
		// TODO main.tsに移動
		// Vue.$userAgentApplication.handleRedirectCallback(() => {
		// 	// console.log('UserAgentApplietion.tokenReceivedCallback()');
		// }, () => {
		// 	// console.log('UserAgentApplietion.errorReceivedCallback()');
		// });
	}

	////////// 以下デバッグモード
	public async onDebugUserTopButtonClick(e: Event): Promise<void> {
		console.info('onDebugUserTopButtonClick');
		this.$router.push(Consts.PATH_USER);
	}
	public async onDebugAdminTopButtonClick(e: Event): Promise<void> {
		console.info('onDebugAdminTopButtonClick');
		this.$router.push(Consts.PATH_ADMIN);
	}
	public async onDebugLoginPopupButtonClick(e: Event): Promise<void> {
		console.info('onDebugLoginPopupButtonClick');
		const regex = new RegExp('^/$|^/admin/?$');
		if (!regex.test(location.pathname)) {
			alert('現在のURLではログインができません。生徒または管理用のログイン画面を表示してください。');
			return;
		}
		const authResult: AuthResult = await AuthUtils.authenticatePopup(Vue.$userAgentApplication);
		console.log('authResult:');
		console.log(authResult);
		if (authResult.result === MsalResult.Success) {
			AppUtils.setAccessTokenInfo(authResult.accessTokenInfo);
			const lastChar: string = location.pathname;
			let newPath: string = 'channels';
			if (lastChar !== '/') {
				newPath = '/' + newPath;
			}
			this.$router.push(location.pathname + newPath);
		}
	}
	public async onDebugLoginRedirectButtonClick(e: Event): Promise<void> {
		console.info('onDebugLoginRedirectButtonClick');
		const regex = new RegExp('^/$|^/admin/?$');
		if (!regex.test(location.pathname)) {
			alert('現在のURLではログインができません。生徒または管理用のログイン画面を表示してください。');
			return;
		}
		const authResult: AuthResult = await AuthUtils.authenticateRedirect(Vue.$userAgentApplication);
		console.log('authResult:');
		console.log(authResult);
	}
	public async onDebugAcquireTokenSilentClick(e: Event): Promise<void> {
		console.info('onDebugAcquireTokenSilentClick');
		const authResult: AuthResult = await AuthUtils.acquireTokenSilent(Vue.$userAgentApplication);
		console.log('authResult:');
		console.log(authResult);
		if (authResult.result === MsalResult.Success) {
			AppUtils.setAccessTokenInfo(authResult.accessTokenInfo);
		}
	}
	public async onDebugSystemLogoutButtonClick(e: Event): Promise<void> {
		console.info('onDebugSystemLogoutButtonClick');
		AppUtils.removeAccessTokenInfo();
	}
	public async onDebugO365LogoutButtonClick(e: Event): Promise<void> {
		console.info('onDebugO365LogoutButtonClick');
		AppUtils.removeAccessTokenInfo();
		Vue.$userAgentApplication.logout();
	}
	////////// 以上デバッグモード

	@Watch("$route", { immediate: true, deep: true })
	private onRouteChange(to: Route, from: Route) {
		const path: string = to.path;

		this.isAccountVisible = false;
		this.isRouterVisible = false;
		this.routerSwitchPathOn = '';
		this.routerSwitchPathOff = '';
		this.isRouterSwitchVisible = false;
		Vue.$isAdmin = false;
		// pathのマッチング
		if (path.match(/^(?:\/(?=$))?$/i) !== null) {
			// /
		} else if (path.match(/^\/admin(?:\/(?=$))?$/i) !== null) {
			// /admin
			Vue.$isAdmin = true;
		} else if (path.match(/^\/channels(?:\/(?=$))?$/i) !== null) {
			// /channels
			this.isAccountVisible = true;
		} else if (path.match(/^\/admin\/channels(?:\/(?=$))?$/i) !== null) {
			// /admin/channels
			this.isAccountVisible = true;
			Vue.$isAdmin = true;
		} else if (
			path.match(/^\/channels\/((?:[^\/]+?))(?:\/(?=$))?$/i) !== null
		) {
			// /channels/:id
			this.routerTitle = "カリキュラム一覧へ戻る";
			this.routerPath = "/channels";
			this.isRouterVisible = true;
			this.isAccountVisible = true;
		} else if (
			path.match(/^\/admin\/channels\/((?:[^\/]+?))(?:\/(?=$))?$/i) !== null
		) {
			// /admin/channels/:id
			this.routerTitle = "カリキュラム一覧へ戻る";
			this.routerPath = "/admin/channels";
			this.isRouterVisible = true;
			this.isAccountVisible = true;
			const channelId: string = this.$route.params.id;
			this.routerSwitchPathOn = `/admin/channels/${channelId}`;
			this.routerSwitchPathOff = `/admin/channels/${channelId}/score`;
			this.isRouterSwitchVisible = true;
			Vue.$isAdmin = true;

		} else if (path.match(/^\/admin\/channels\/((?:[^\/]+?))\/score(?:\/(?=$))?$/i) !== null) {
			// /admin/channels/:id/score
			this.routerTitle = "カリキュラム一覧へ戻る";
			this.routerPath = "/admin/channels/";
			this.isRouterVisible = true;
			this.isAccountVisible = true;
			const channelId: string = this.$route.params.id;
			this.routerSwitchPathOn = `/admin/channels/${channelId}`;
			this.routerSwitchPathOff = `/admin/channels/${channelId}/score`;
			this.isRouterSwitchVisible = true;
			this.isRouterSwitchOn = true;
			Vue.$isAdmin = true;
		}
		this.isAdmin = Vue.$isAdmin;
	}

	private getUserName(name: string): void {
		this.userName = name;
	}

	private getGroups(groups: Groups): void {
		const groupId: string | null = localStorage.getItem(Consts.LOCAL_STORAGE_KEY_USER_GROUPID);
		if (groupId === null) {
			return;
		}
		const group = groups.get(groupId);
		if (group === null) {
			return;
		}
		this.isGroupListVisible = false;
		if (groups.value.length > 1) {
			this.isGroupListIconVisible = true;
		} else {
			this.isGroupListIconVisible = false;
		}
		this.groupId = group.id;
		this.groups = groups;
		this.groupName = group.displayName;
	}

	private async onAccountClick(e: Event): Promise<void> {
		this.logoutConfirmationTitle = 'ログアウト';
		this.logoutConfirmationMessage = 'ログアウトしますか？';
		this.isLogoutConfirmationVisible = true;
	}

	private async onLogoutConfirmationOkClick(e: Event): Promise<void> {
		this.logoutConfirmationOkButtonDisabled = true;
		this.logoutConfirmationCancelButtonDisabled = true;
		AppUtils.removeAccessTokenInfo();
		Vue.$userAgentApplication.logout();
	}

	private async onLogoutConfirmationCancelClick(e: Event): Promise<void> {
		this.isLogoutConfirmationVisible = false;
	}

	private async showLogoutConfirmation(title: string, message: string): Promise<void> {
		this.logoutConfirmationTitle = title;
		this.logoutConfirmationMessage = message;
		this.isLogoutConfirmationVisible = true;
	}

	private onGroupNameClick(): void {
		if (!this.isGroupListIconVisible) {
			return;
		}
		this.isGroupListVisible = !this.isGroupListVisible;
	}

	private onGroupListItemClick(groupId: string): void {
		this.isGroupListVisible = !this.isGroupListVisible;
		if (this.groupId === groupId) {
			return;
		}
		const group = this.groups.get(groupId);
		if (group === null) {
			return;
		}
		this.groupId = group.id;
		this.groupName = group.displayName;
		localStorage.setItem(Consts.LOCAL_STORAGE_KEY_USER_GROUPID, groupId);
		if (Vue.$isAdmin) {
			this.$router.push(Consts.PATH_ADMIN_CHANNELS);
		}
	}
}
